import { CreateNotificationRuleBasicInformationForm } from '@/features/notification-rules/components/create-notification-rule/steps-form/create-notification-rule-basic-information-form.tsx';
import { CreateNotificationRuleConditionsForm } from '@/features/notification-rules/components/create-notification-rule/steps-form/create-notification-rule-conditions-form.tsx';
import { CreateNotificationRuleMessageTemplateForm } from '@/features/notification-rules/components/create-notification-rule/steps-form/create-notification-rule-message-template-form.tsx';
import { CreateNotificationRuleOtherOptionsForm } from '@/features/notification-rules/components/create-notification-rule/steps-form/create-notification-rule-other-options-form.tsx';
import {
  basicInformationFormSchema,
  conditionsFormSchema,
  messageTemplateFormSchema,
  otherOptionsFormSchema,
} from '@/features/notification-rules/schemas/create-notification-rule.schema.ts';

export const CREATE_NOTIFICATION_RULES_STEPS = [
  {
    step: 1,
    title: 'Basic Information',
    Element: CreateNotificationRuleBasicInformationForm,
    schema: basicInformationFormSchema,
  },
  {
    step: 2,
    title: 'Conditions',
    Element: CreateNotificationRuleConditionsForm,
    schema: conditionsFormSchema,
  },
  {
    step: 3,
    title: 'Notification Description',
    Element: CreateNotificationRuleMessageTemplateForm,
    schema: messageTemplateFormSchema,
  },
  {
    step: 4,
    title: 'Other options',
    Element: CreateNotificationRuleOtherOptionsForm,
    schema: otherOptionsFormSchema,
  },
] as const;
